import { useEffect, useRef } from 'react';
import { useTheme } from '../context/ThemeContext';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../utils/translations';

const useSkills = () => {
    const { theme } = useTheme();
    const { language } = useLanguage();
    const skillsRef = useRef(null);
    
    // Obtener traducciones según el idioma actual
    const t = translations[language].skills;

    // Mapeo de iconos para categorías (por nombres)
    const categoryIconNames = {
        'Frontend': 'code',
        'Backend': 'layer-group',
        'Bases de Datos': 'database',
        'Databases': 'database',
        'Herramientas': 'tools',
        'Tools': 'tools'
    };

    // Colores para las categorías
    const categoryColors = {
        'Frontend': '#4361EE',
        'Backend': '#4895EF',
        'Bases de Datos': '#3F37C9',
        'Databases': '#3F37C9',
        'Herramientas': '#4CC9F0',
        'Tools': '#4CC9F0'
    };

    useEffect(() => {
        // Configurar el IntersectionObserver para las tarjetas de habilidades
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('animated');
                    }
                });
            },
            { threshold: 0.1 }
        );
        
        // Observar las tarjetas de habilidades
        const skillCards = document.querySelectorAll('.skill-category-card');
        const softCards = document.querySelectorAll('.soft-skill-card');
        
        skillCards.forEach(card => observer.observe(card));
        softCards.forEach(card => observer.observe(card));

        return () => {
            skillCards.forEach(card => observer.unobserve(card));
            softCards.forEach(card => observer.unobserve(card));
        };
    }, []);

    return {
        theme,
        t,
        skillsRef,
        categoryIconNames,
        categoryColors
    };
};

export default useSkills;